<template>
  <div class="page--contact" id="view">
    <hero-section />
    <form-section />
    <ScheduleNow getInTouchText="Want to Skip the Emails?" buttonText="Lets Talk" subText="Schedule a quick meeting with us" />
    <news-letter backgroundColor="#ffffff" />

  </div>
</template>

<script>
// Local Components
import HeroSectionVue from "@/views/contact/Sections/HeroSection.vue";
import FormSection from "@/views/contact/Sections/FormSection.vue";
import ScheduleNow from '@/views/service/components/GetInTouch.vue';
import Newsletter from '../resources/partials/Newsletter.vue';


export default {
  name: "ContactPage",
  components: {
    "hero-section": HeroSectionVue,
    "form-section": FormSection,
    'ScheduleNow': ScheduleNow,
    'news-letter': Newsletter,

  },
  created() {
    document.getElementById("loaderSection").classList.add("d-none");
  },
};
</script>

<style>
</style>
